module.exports = __webpack_public_path__ + "static/teclado-2e23785e5419918b0dbb74a81a829e80.jpg";